
import Maps from '@/components/maps';
import { MapZoomLevel } from '@/components/maps/enums';
import MapsMarkerHelper from '@/components/maps/entities/helpers';

export default {
  name: 'ListingMap',
  components: {
    Maps,
  },
  props: {
    listing: {
      required: true,
      type: Object,
    },
  },
  data() {
    return {
      MapZoomLevel,
    };
  },
  computed: {
    center() {
      const [lng = 0, lat = 0] = this.listing.location;

      return { lat, lng };
    },
    markersData() {
      return [{
        position: this.center,
        icon: MapsMarkerHelper.getListingIcon(this.listing),
      }];
    },
  },
};
